var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('Alert'),_c('v-container',{attrs:{"fluid":""}},[_c('ManagementReports')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }